package com.dwarshb.bms

import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.ui.ExperimentalComposeUiApi
import androidx.compose.ui.Modifier
import androidx.compose.ui.window.CanvasBasedWindow
import kotlinx.browser.document
import kotlinx.browser.window
import org.jetbrains.skiko.wasm.onWasmReady
import org.w3c.dom.get

@OptIn(ExperimentalComposeUiApi::class)
fun main() {
    onWasmReady {
        val url = window.location.href
        println("URL:$url")

        CanvasBasedWindow(
            title = "Compose App",
            canvasElementId = "ComposeTarget",
        ) {
            MaterialTheme {
                Box(
                    modifier = Modifier.fillMaxSize(),
                ) {
                    App(null,url)
                }
            }
        }
    }
}